<template>
  <div class="container">
    <div class="one">
      <div class="title">智能审计</div>
      <div class="content">
        邦盛科技智能审计是针对机构的审计管理、审计作业、技术分析等应用需求，建立的一套集成了智能化技术、审计体系运作管理、个性化订制服务等在内强大的管理系统。
      </div>
    </div>
    <div class="two">
      <div class="title">应用场景</div>
      <div class="content2">
        <div class="box" v-for="item in application" :key="item.id">
          <div
            class="imgs"
            :style="{
              'background-image': `url(${item.imgUrl})`,
            }"
          ></div>
          <div class="titles">{{ item.title }}</div>
        </div>
      </div>
    </div>
    <div class="three">
      <div class="title">产品特色</div>
      <div class="content3">
        <div class="box2" v-for="item in features" :key="item.id">
          <div
            class="left"
            :style="{
              'background-image': `url(${item.imgUrl})`,
            }"
          ></div>
          <div class="right">
            <div class="titless">{{ item.title }}</div>
            <div class="content3">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Audit",
  components: {},
  data() {
    return {
      application: [
        {
          id: 12,
          imgUrl: require("./img/xindaizijinshenji.png"),
          title: "信贷资金审计",
        },
        {
          id: 11,
          imgUrl: require("./img/guimianyunyinshenji.png"),
          title: "柜面运营审计",
        },
        {
          id: 21,
          imgUrl: require("./img/yuangongshenji.png"),
          title: "员工审计",
        },
        {
          id: 31,
          imgUrl: require("./img/caiwufeiyongshenji.png"),
          title: "财务费用审计",
        },
        { id: 41, imgUrl: require("./img/lirenshenji.png"), title: "离任审计" },
        {
          id: 51,
          imgUrl: require("./img/neibuzhuantishenji.png"),
          title: "内部专题审计",
        },
        { id: 61, imgUrl: require("./img/waibushenji.png"), title: "外部审计" },
      ],
      features: [
        {
          id: 1001,
          imgUrl: require("./img/shenjizuoye.jpg"),
          title: "标准化的审计作业",
          content:
            "系统能够提供标准化的审计作业流程、模板、角色权限配置，实现审计作业的标准化、自动化、数字化",
        },
        {
          id: 1002,
          imgUrl: require("./img/jianmofenxi.jpg"),
          title: "强大的建模分析工具",
          content:
            "针对审计数据分析的需求，系统打造了一套高效的指标平台，用于加工相关指标，同时配套拖拉拽、开放式、SQL等分析工具，实现科学、灵活的数据分析机制",
        },
        {
          id: 1003,
          imgUrl: require("./img/gongjujicheng.jpg"),
          title: "智能化工具集成",
          content:
            "系统打造了邦盛科技流式计算引擎、知识图谱引擎、智能化机器学习引擎、OCR与NLP等诸多业内前沿的组件，帮助客户实现智能化审计升级",
        },
        {
          id: 1004,
          imgUrl: require("./img/chaxunchazheng.jpg"),
          title: "丰富多维的查询查证功能",
          content:
            "在查询查证方面，系统建立了一套穿透溯源分析、关联模型分析、组合模型分析、精细化查询查证等一系列工具体系，提升查询查证的科学性和效率",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  box-sizing: border-box;
  padding: 40px;
  margin: 90px auto 20px auto;
  width: 980px;
  background-color: #fff;
  .title {
    font-size: 18px;
    font-weight: bold;
    color: #0c6fb5;
    line-height: 18px;
    padding-left: 20px;
    background: url("~@/assets/arrow.png") no-repeat center left;
  }
  .one {
    .content {
      font-size: 14px;
      line-height: 32px;
      margin-top: 11px;
      color: #5b5b5b;
    }
  }
  .two {
    margin-top: 60px;
    .content2 {
      display: flex;
      margin-top: 20px;
      .box {
        width: 90px;
        height: 90px;
        text-align: center;
        margin-right: 10px;
        .imgs {
          width: 50px;
          height: 60px;
          background-repeat: no-repeat;
          background-size: contain;
          display: inline-block;
        }
        .titles {
          font-size: 14px;
          color: #5b5b5b;
          text-align: center;
          margin-top: 5px;
        }
      }
    }
  }
  .three {
    margin-top: 60px;
    .content3 {
      margin-top: 20px;
      .box2 {
        margin-bottom: 40px;
        display: flex;
        .left {
          width: 58px;
          height: 58px;
          background-repeat: no-repeat;
          background-size: contain;
        }
        .right {
          margin-left: 20px;
          .titless {
            font-weight: bold;
            color: #0c6fb5;
            line-height: 14px;
            margin-top: 3px;
          }
          .content3 {
            font-size: 14px;
            color: #5b5b5b;
          }
        }
      }
    }
  }
}
</style>
